import { zodResolver } from '@hookform/resolvers/zod'
import { addWeeks } from 'date-fns'
import { useForm } from 'react-hook-form'
import { View } from 'react-native'
import { Portal } from 'react-native-paper'
import { StyleSheet } from 'react-native-unistyles'
import z from 'zod'

import FormFieldDate from '@/components/form/FormFieldDate'
import UniButton from '@/components/unistyles/UniButton'
import UniIconButton from '@/components/unistyles/UniIconButton'
import UniModal from '@/components/unistyles/UniModal'
import UniText from '@/components/unistyles/UniText'

interface Props {
  isOpen: boolean
  onClose: (fecalFollowUpDate?: Date) => void
}

const formSchema = z.object({
  lastFecalMedDoseDate: z.date(),
})

const FosterFecalFollowupModal = ({ isOpen, onClose }: Props) => {
  const { control, formState, handleSubmit } = useForm({
    mode: 'onBlur',
    resolver: zodResolver(formSchema),
  })

  const onSubmit = handleSubmit((data) => {
    onClose(addWeeks(data.lastFecalMedDoseDate, 2))
  })

  return (
    <Portal>
      <UniModal
        contentContainerStyle={styles.modalContent}
        onDismiss={onClose}
        style={styles.modal}
        visible={isOpen}
      >
        <View style={styles.modalHeader}>
          <UniText style={styles.modalTitle}>Fecal Follow-Up</UniText>
          <UniIconButton icon="close" onPress={() => onClose(undefined)} />
        </View>
        <View style={styles.modalBody}>
          <UniText style={styles.modalBodyText}>
            You should bring in a new fecal sample two weeks after their last
            medication.
          </UniText>
          <UniText style={styles.modalBodyText}>
            We'll set the follow-up date and then send you an email reminder
            when it's time.
          </UniText>
          <View style={styles.lastDosageContainer}>
            <UniText style={styles.modalBodyText}>
              What day will they get their last dosage?
            </UniText>
            <FormFieldDate
              control={control}
              errors={formState.errors}
              fieldName="lastFecalMedDoseDate"
              label="Last Dose"
              required
              style={styles.dateField}
            />
          </View>
        </View>
        <View style={styles.modalFooter}>
          <UniButton
            mode="contained"
            onPress={onSubmit}
            style={styles.modalButton}
          >
            OK
          </UniButton>
        </View>
      </UniModal>
    </Portal>
  )
}

const styles = StyleSheet.create((theme) => {
  return {
    dateField: {
      height: 50,
    },
    lastDosageContainer: {
      alignItems: 'center',
      flexDirection: {
        xs: 'column',
        md: 'row',
      },
      gap: theme.tokens.spacing[4],
    },
    modal: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalBody: {
      marginBottom: theme.tokens.spacing[4],
    },
    modalBodyText: {
      fontSize: 16,
    },
    modalButton: {
      width: 100,
    },
    modalContent: {
      backgroundColor: theme.colors.background,
      padding: theme.tokens.spacing[4],
      width: '90%',
    },
    modalFooter: {
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    modalHeader: {
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: theme.tokens.spacing[3],
    },
    modalTitle: {
      fontSize: 20,
      fontWeight: 'bold',
    },
  }
})
export default FosterFecalFollowupModal
